<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">APP 皮肤管理</div>
          <div class="muted">上传与 skin1 结构一致的 zip 包，APP 下载解压后可应用为本地皮肤。</div>
        </div>
        <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
      </div>

      <el-form :model="form" label-width="110px" class="skin-form">
        <el-form-item label="皮肤名称">
          <el-input v-model="form.name" placeholder="例如：天选姬魔幻青"></el-input>
        </el-form-item>
        <el-form-item label="皮肤封面">
          <div class="upload-line">
            <el-input v-model="form.image" placeholder="可上传封面或填写图片地址"></el-input>
            <el-upload
              action="/api/admin/app/skin/upload-image"
              :headers="uploadHeaders"
              :show-file-list="false"
              accept=".png,.jpg,.jpeg,.gif,.webp"
              :on-success="uploadImageSuccess"
            >
              <el-button icon="el-icon-picture">上传封面</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="上传皮肤包">
          <el-upload
            action="/api/admin/app/skin/upload"
            :headers="uploadHeaders"
            :show-file-list="false"
            accept=".zip"
            :before-upload="beforeZipUpload"
            :on-success="uploadZipSuccess"
          >
            <el-button type="primary" icon="el-icon-upload">选择 zip 皮肤包</el-button>
          </el-upload>
          <span class="muted inline-tip">zip 根目录应包含 color.json、底栏图标和顶部背景等资源。</span>
        </el-form-item>
        <el-form-item label="下载地址">
          <el-input v-model="form.url" placeholder="上传后自动填入"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存皮肤</el-button>
          <el-button @click="resetForm">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border height="48vh">
        <el-table-column label="封面" width="150">
          <template slot-scope="scope">
            <el-image class="cover" :src="scope.row.image" referrerpolicy="no-referrer" fit="cover" :preview-src-list="[scope.row.image]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="名称" min-width="160">
          <template slot-scope="scope">
            <div class="skin-name">{{ scope.row.name }}</div>
            <div class="muted">ID：{{ scope.row.id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.is_default) === 1 ? 'success' : 'primary'">
              {{ Number(scope.row.is_default) === 1 ? "默认" : "下载" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">{{ Number(scope.row.status) === 1 ? "启用" : "停用" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="zip地址" min-width="260">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.is_default) === 1" class="muted">默认皮肤使用 APP 内置资源</span>
            <el-link v-else :href="scope.row.url" target="_blank" type="primary">{{ scope.row.url }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="Number(scope.row.is_default) !== 1" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button v-if="Number(scope.row.is_default) !== 1" type="text" class="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { isSuccess } from "./appAdminUtils.js";

export default {
  name: "appSkin",
  data() {
    return {
      list: [],
      form: this.emptyForm(),
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem("token") || "",
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    emptyForm() {
      return {
        id: "",
        name: "",
        image: "",
        url: "",
        sort: 0,
        status: 1,
      };
    },
    getList() {
      post("/api/admin/app/skin/list", {}).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "皮肤列表获取失败");
        }
      });
    },
    beforeZipUpload(file) {
      const ok = /\.zip$/i.test(file.name);
      if (!ok) {
        this.$message.error("只能上传 zip 皮肤包");
      }
      return ok;
    },
    uploadZipSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.form.url = data.url;
      this.$notify({ title: "上传成功", message: "皮肤包地址已填入", type: "success" });
    },
    uploadImageSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.form.image = data.url;
    },
    save() {
      if (!this.form.name || !this.form.url) {
        this.$message.error("请填写皮肤名称并上传 zip 包");
        return;
      }
      post("/api/admin/app/skin/save", this.form).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.resetForm();
          this.getList();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    edit(row) {
      this.form = Object.assign(this.emptyForm(), row, { url: row.url || row.package_url || "" });
    },
    remove(row) {
      this.$confirm("删除后 APP 将不再展示该皮肤，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        post("/api/admin/app/skin/delete", { id: row.id }).then((res) => {
          if (isSuccess(res)) {
            this.$notify({ title: "删除成功", message: res.data.msg, type: "success" });
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      }).catch(() => {});
    },
    resetForm() {
      this.form = this.emptyForm();
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.title {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.skin-form {
  max-width: 920px;
  margin-bottom: 18px;
}
.upload-line {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
}
.inline-tip {
  margin-left: 12px;
}
.cover {
  width: 110px;
  height: 62px;
  border-radius: 4px;
  background: #eef7fb;
}
.skin-name {
  color: #1f2d3d;
  font-weight: 700;
}
.danger {
  color: #f56c6c;
}
</style>
